<template>
  <div>
    <br>
    <span v-for="(data,i) in quicklinkSummaryView.answer" :key="i">
      <h4
        class="header-Text text-left mb-3"
        v-if="data.answerList.length > 0"
      >{{data.quickLinkDescription}}</h4>
      <div class="card-background">
        <table class="table table-striped">
          <thead v-if="data.answerList.length > 0">
            <tr>
              <th
                v-for="(header,index) in data.answerList[0].answer"
                :key="index"
              >{{header.displayName}}</th>
            </tr>
          </thead>
          <tbody class="table-text text-left" v-if="data.answerList.length > 0">
            <tr v-for="(header,index) in data.answerList" :key="index">
              <td v-for="(answer,index) in header.answer" :key="index">
                <span v-if="answer.controlType == 'DP'">{{dateFormat(answer.keyValue)}}</span>
                <span v-if="answer.controlType =='U'">
                  <a
                    @click="showFile(answer.keyValue)"
                    href="#"
                  >{{getAttachmentName(answer.keyValue)}}</a>
                </span>
                <span
                  v-if="answer.controlType !='U' && answer.controlType !='DP'"
                >{{answer.keyValue}}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
    <br />
    <span v-if="quicklinkSummaryView.contacts.length > 0">
      <h4 class="header-Text text-left mb-1">Contact Details</h4>
      <div class="card-background">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th>Name</th>
              <th>Designation</th>
              <th>Department</th>
              <th>Category</th>
              <th>Mobile Number</th>
              <th>Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(contact,index) in quicklinkSummaryView.contacts" :key="index">
              <td>{{contact.name}}</td>
              <td>{{contact.designation}}</td>
              <td>{{contact.department}}</td>
              <td>{{contact.category}}</td>
              <td>{{contact.mobileNumber}}</td>
              <td>{{contact.email}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
    <br />
    <span v-if="quicklinkSummaryView.financeDetails.length > 0">
      <h4 class="header-Text text-left mb-1">Financial Performance</h4>
      <div class="card-background">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th>Financial Year</th>
              <th>Assets</th>
              <th>Gross Profit</th>
              <th>Net Profit</th>
              <th>RoA</th>
              <th>RoCE</th>
              <th>Turnover</th>
              <th>Attachment</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(finance,index) in quicklinkSummaryView.financeDetails" :key="index">
              <td>{{finance.financeYear}}-{{finance.financeYear+1}}</td>
              <td>{{finance.assetValue}}</td>
              <td>{{finance.grossProfit}}</td>
              <td>{{finance.netProfit}}</td>
              <td>{{finance.roa}}</td>
              <td>{{finance.roce}}</td>
              <td>{{finance.turnover}}</td>
              <td>
                <a
                  v-if="finance.financialAttachment!=null"
                  @click="showFile(finance.financialAttachment)"
                  href="#"
                >{{getAttachmentName(finance.financialAttachment)}}</a>
                <span v-else>-</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>

    <span v-if="answerNumber.indexOf('PBD') > -1 &&
      quicklinkSummaryView.approvedBankDetails && quicklinkSummaryView.approvedBankDetails.length > 0"
       style="margin-bottom: 20px;opacity: 0.6;display: block;">
      <h4 class="header-Text text-left mb-1">Existing Bank Details</h4>
      <div class="card-background">
        <table class="table table-striped mb-0">
          <thead>
            <tr class="oldbankheader">
              <th>Account Category</th>
              <th>Account Number</th>
              <th>Payment in favour of</th>
              <th>Account Type</th>
              <th>Payment Mode</th>
              <th>Bank Name</th>
              <th v-if="country == 'India'">IFSC Code</th>
              <th v-if="country != 'India'">Swift Code</th>
              <th v-if="country != 'India'">IBAN Number</th>
              <th v-if="country != 'India'">Sort Code</th>
              <th>Attachment</th>
            <th>Payment Ref Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(bank,index) in quicklinkSummaryView.approvedBankDetails ? quicklinkSummaryView.approvedBankDetails : []" :key="index">
              <td>{{bank.accountCategory}}</td>
              <td>{{bank.accountNumber}}</td>
              <td>{{bank.paymentInfavourOf}}</td>
              <td>{{bank.accountType}}</td>
              <td>{{bank.paymentMode}}</td>
              <td>{{bank.bankName}}</td>
              <td v-if="country == 'India'">{{bank.ifscCode}}</td>
              <td v-if="country != 'India'">{{bank.swiftBicCode}}</td>
              <td v-if="country != 'India'">{{bank.ibanNumber}}</td>
              <td v-if="country != 'India'">{{bank.sortCode}}</td>
              <td><a
                  v-if="bank.documentId!=null"
                  @click="showFile(bank.documentId)"
                  href="#"
                >{{getAttachmentName(bank.documentId)}}</a>
                <span v-else>-</span></td>                
              <td>{{bank.paymentRefMailId}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
    <span v-if="quicklinkSummaryView.bankDetails.length > 0">
      <h4 class="header-Text text-left mb-1">New Proposed Bank Details</h4>
      <div class="card-background">
        <table class="table table-striped mb-0">
          <thead>
            <tr>
              <th>Account Category</th>
              <th>Account Number</th>
              <th>Payment in favour of</th>
              <th>Account Type</th>
              <th>Payment Mode</th>
              <th>Bank Name</th>
              <th v-if="country == 'India'">IFSC Code</th>
              <th v-if="country != 'India'">Swift Code</th>
              <th v-if="country != 'India'">IBAN Number</th>
              <th v-if="country != 'India'">Sort Code</th>
              <th>Attachment</th>
            <th>Payment Ref Email</th>
            </tr>
          </thead>
          <tbody class="text-left">
            <tr v-for="(bank,index) in quicklinkSummaryView.bankDetails" :key="index">
              <td>{{bank.accountCategory}}</td>
              <td>{{bank.accountNumber}}</td>
              <td>{{bank.paymentInfavourOf}}</td>
              <td>{{bank.accountType}}</td>
              <td>{{bank.paymentMode}}</td>
              <td>{{bank.bankName}}</td>
              <td v-if="country == 'India'">{{bank.ifscCode}}</td>
              <td v-if="country != 'India'">{{bank.swiftBicCode}}</td>
              <td v-if="country != 'India'">{{bank.ibanNumber}}</td>
              <td v-if="country != 'India'">{{bank.sortCode}}</td>
              <td><a
                  v-if="bank.documentId!=null"
                  @click="showFile(bank.documentId)"
                  href="#"
                >{{getAttachmentName(bank.documentId)}}</a>
                <span v-else>-</span></td>
              <td>{{bank.paymentRefMailId}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </span>
    <w-loading-spinner :loadSpinner="loading" />
  </div>
</template>

<script>
import { SummaryServices } from "../../services/summaryService";
const SummaryService = new SummaryServices();
import moment from "moment";
import LoadingSpinner from "../../widgets/LoadingSpinner";
import TextInput from "../../widgets/TextInput.vue";
import DropDown from "../../widgets/DropDown";
import Datepicker from "../../widgets/DatePicker";
import DatePicker from "vue2-datepicker";
import partnertable from "../../widgets/partner-table-collapsable";
export default {
  props: ["answerNumber","country"],
  components: {
    "w-text-input": TextInput,
    "w-drop-down": DropDown,
    "w-datepicker": Datepicker,
    "w-collapse-table": partnertable,
    "w-loading-spinner": LoadingSpinner,
    DatePicker
  },
  data() {
    return {
      loading:false,
      enableSubmit: true,
      quicklinkSummaryView: "",
      documentNumber: "PQL190102000001"
    };
  },
  watch: {},
  created() {
    this.getQuicklinkDetails();
  },
  computed: {},
  methods: {
    getQuicklinkDetails() {
      SummaryService.getQuicklinkDetails(this.answerNumber).then(resp => {
        this.quicklinkSummaryView = resp.response;
      });
    },
    getAttachmentName(documentId) {
      if (documentId) {
        let attachmentName = "";
        attachmentName = documentId.split(/_(.+)/)[1]
          ? documentId.split(/_(.+)/)[1]
          : documentId;
        return attachmentName;
      }
    },
    dateFormat(date) {
      return moment(date).format("Do MMMM YYYY");
    },
    showFile(event) {
      this.loading = true;
      SummaryService.downLoadDocument(event).then(res => {
        this.loading = false;
      });
    }
  }
};
</script>

<style scoped>
.oldbankheader th{
    background: #949494
}
.card-background {
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.16);
  background-color: #ffffff;
}
.table-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
}
.header-Text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 18px;
  font-weight: bold;
}
</style>

<style>
.table thead th {
  font-size: 15px !important;
  font-family: "Source Sans Pro", sans-serif;
  vertical-align: bottom;
  border-bottom: 2px solid #d0d3d6;
  background-color: #6192b1;
  position: sticky;
  color: #fff;
  text-align: left;
}
</style>